import { createStrictContext } from 'utils/createContext'
import {
  useCasDispositionTypesQuery,
  useEditCasDispositionTypeMutation,
} from 'schema'
import {
  DefaultMutationHookOptions,
  DefaultQueryHookOptions,
} from 'utils/defaults'
import { CASDispositionTypeContext } from './types'
import { simpleEditNotification } from 'hooks/notificationHandler'
import { useProjectContext } from 'context/ProjectContext'

const { Provider, useContextFn } =
  createStrictContext<CASDispositionTypeContext>('DispositionTypesContext')

export const useDispositionTypesContext = useContextFn

const DispositionTypesProvider: React.FC = ({ children }) => {
  const { projectId } = useProjectContext()
  const { data, loading, refetch } = useCasDispositionTypesQuery({
    ...DefaultQueryHookOptions,
    variables: { projectId },
  })
  const [editFn] = useEditCasDispositionTypeMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      editCASDispositionType: {
        dispositionType: { name },
      },
    }) => simpleEditNotification(name),
  })
  return (
    <Provider
      value={{
        loading,
        refetch,
        dispositionTypes: data?.casDispositionTypes?.records ?? [],
        edit: async (input) => {
          await editFn({ variables: { input } })
        },
      }}
    >
      {children}
    </Provider>
  )
}

export default DispositionTypesProvider
